module.exports = __webpack_public_path__ + "static/media/treehouse-home-page-footer.76ca9129.jpg";